import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { SquadCastComponentsModule } from '../../components/squadcast.components.module';
import { NotificationsPage } from './notifications.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: NotificationsPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [NotificationsPage],
})
export class NotificationsPageModule {}
